import apiClient from './apiClient';

export const createApiKey = async ({ name, scopes, expiresInDays }) => {
  const body = { name };
  if (scopes && scopes.length > 0) {
    body.scopes = scopes;
  }
  if (expiresInDays) {
    body.expiresInDays = expiresInDays;
  }
  const response = await apiClient.post('/accounts/api-keys', body);
  return response.data?.data || response.data;
};

export const listApiKeys = async () => {
  const response = await apiClient.get('/accounts/api-keys');
  return response.data?.data || response.data;
};

export const revokeApiKey = async (keyId) => {
  const response = await apiClient.delete(`/accounts/api-keys/${keyId}`);
  return response.data?.data || response.data;
};
